import { Route, Routes, useLocation } from 'react-router-dom';
import jwt from 'jsonwebtoken';
import { lazy, useEffect } from 'react';
// import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/loader/Loadable';
import UserToken from '../components/UserToken';
import { endSession, watchSessionInOtherTabs } from '../constants/authSession';
import CashCollection from '../views/fleetnexis/payments/CashCollection';
import ContactEnquiry from '../views/fleetnexis/website/ContactEnquiry';
import BookingEnquiry from '../views/fleetnexis/website/BookingEnquiry';
import Teams from '../views/fleetnexis/teams/Index';
import MapFilterForm from '../views/fleetnexis/location/MapFilterForm';
import Editquote from '../views/fleetnexis/quotation/Editquote';
import Brands from '../views/fleetnexis/store/Brands';
import AreaManagement from '../views/fleetnexis/management/AreaManagement';
import CategoryManagement from '../views/fleetnexis/management/CategoryManagement';
import MobileMedia from '../views/fleetnexis/management/MobileMedia';
import RolesCountries from '../views/fleetnexis/management/RolesCountries';
import PaymentGateway from '../views/fleetnexis/management/PaymentGateway';
import RequireRole from '../components/common/RequireRole';
import { ROLES, getStoredUser } from '../constants/tenancy';

import TeamSlotSchedule from '../views/fleetnexis/booking/TeamSlotSchedule';
/****Layouts*****/

// Finance, Management and the Store/HR pages that only add or edit are for
// admins; staff land on the dashboard (the API refuses them too).
// eslint-disable-next-line react/prop-types
const AdminsOnly = ({ children }) => <RequireRole roles={[ROLES.SUPER_ADMIN, ROLES.TENANT_ADMIN]}>{children}</RequireRole>;

const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
/***** Pages ****/

const Classic = Loadable(lazy(() => import('../views/dashboards/Classic')));
const LoginFormik = Loadable(lazy(() => import('../views/fleetnexis/Login')));

// users
const AllUsers = Loadable(lazy(() => import('../views/fleetnexis/AllUsers')));
const FilterUser = Loadable(lazy(() => import('../views/fleetnexis/FilterUser')));
const NoResponse = Loadable(lazy(() => import('../views/fleetnexis/NoResponse')));
const NotRetrieved = Loadable(lazy(() => import('../views/fleetnexis/NotRetrieved')));
const RetrievedUser = Loadable(lazy(() => import('../views/fleetnexis/RetrievedUser')));
const UsersByStatus = Loadable(lazy(() => import('../views/fleetnexis/UsersByStatus')));
const UserAnalysis = Loadable(lazy(() => import('../views/fleetnexis/users/userAnalysis')));

//Driver Helper
const DriverHelper = Loadable(lazy(() => import('../views/fleetnexis/driver-helper/driverHelper')));

//Reports
const Reports = Loadable(lazy(() => import('../views/fleetnexis/reports/Reports')));
const WorkStation = Loadable(lazy(() => import('../views/fleetnexis/reports/WorkStation')));
const DeleteSystem = Loadable(lazy(() => import('../views/fleetnexis/reports/DeleteSystem')));
const Cafu = Loadable(lazy(() => import('../views/fleetnexis/reports/Cafu')));

//Bonus — page hidden; sidebar entries commented out too.
// const Bonus = Loadable(lazy(() => import('../views/fleetnexis/bonus/Bonus')));

//location
const MapLocation = Loadable(lazy(() => import('../views/fleetnexis/location/Index')));
const TodayMapLocation = Loadable(lazy(() => import('../views/fleetnexis/location/IndexLive')));
const BookingMonthlyAnalysis = Loadable(
  lazy(() => import('../views/fleetnexis/location/BookingMonthlyAnalysis')),
);

//Service
const AddService = Loadable(lazy(() => import('../views/fleetnexis/services/AddService')));
const ViewServices = Loadable(lazy(() => import('../views/fleetnexis/services/ViewServices')));
const EditServices = Loadable(lazy(() => import('../views/fleetnexis/services/EditServices')));
const SortWallet = Loadable(lazy(() => import('../views/fleetnexis/driver-helper/SortWallet')));
const QuoteGenerator = Loadable(lazy(() => import('../views/fleetnexis/quotation/quote-generator')));
const SlotBooking = Loadable(lazy(() => import('../views/fleetnexis/booking/SlotBooking')));
const ViewBookings = Loadable(lazy(() => import('../views/fleetnexis/booking/ViewBookings')));
// const UserLogs = Loadable(lazy(() => import('../views/fleetnexis/logs/UserLogs')));
// const UserNewLogs = Loadable(lazy(() => import('../views/fleetnexis/logs/UserNewLogs')));
const EditBookingNew = Loadable(lazy(() => import('../views/fleetnexis/booking/EditBookingNew')));
const BookingQuotePdf = Loadable(lazy(() => import('../views/fleetnexis/quotation/BookingQuotePdf')));
const Complaints = Loadable(lazy(() => import('../views/fleetnexis/complaints/Index')));
const ViewComplaints = Loadable(lazy(() => import('../views/fleetnexis/complaints/ViewComplaints')));
const AddComplaints = Loadable(lazy(() => import('../views/fleetnexis/complaints/AddComplaints')));
const Consent = Loadable(lazy(() => import('../views/fleetnexis/workstation/Consent')));
const Schedule = Loadable(lazy(() => import('../views/fleetnexis/schedule/Index')));
const WorkStationView = Loadable(lazy(() => import('../views/fleetnexis/workstation/Index')));
const Quotation = Loadable(lazy(() => import('../views/fleetnexis/quotation/Quotation')));
const Expense = Loadable(lazy(() => import('../views/fleetnexis/expense/Index')));
const Leads = Loadable(lazy(() => import('../views/fleetnexis/booking/Leads')));
const EditBookingWorkstation = Loadable(
  lazy(() => import('../views/fleetnexis/workstation/EditBooking')),
);
// Booking By ID — page hidden; sidebar entries commented out too.
// const GetBookingDetailById = Loadable(
//   lazy(() => import('../views/fleetnexis/booking/GetBookingDetailById')),
// );
const ViewQuotation = Loadable(lazy(() => import('../views/fleetnexis/quotation/ViewQuotation')));
const AudioRecorder = Loadable(lazy(() => import('../views/fleetnexis/booking/AudioRecorder')));
const Issues = Loadable(lazy(() => import('../views/fleetnexis/servicemanapp/Issues')));
const Inspection = Loadable(lazy(() => import('../views/fleetnexis/servicemanapp/Inspection')));
const InspectionDetail = Loadable(
  lazy(() => import('../views/fleetnexis/servicemanapp/InspectionDetail')),
);
const StoreList = Loadable(lazy(() => import('../views/fleetnexis/store/StoreList')));
const AddProduct = Loadable(lazy(() => import('../views/fleetnexis/store/AddProduct')));
const EditProduct = Loadable(lazy(() => import('../views/fleetnexis/store/EditProduct')));
const TransferList = Loadable(lazy(() => import('../views/fleetnexis/store/TransferList')));
const QuantityAlert = Loadable(lazy(() => import('../views/fleetnexis/store/QuantityAlert')));
// const Recharge = Loadable(lazy(() => import('../views/fleetnexis/recharge/Index')));
const SaleReport = Loadable(lazy(() => import('../views/fleetnexis/reports/SaleReport')));
const TeamAvailibilityChart = Loadable(
  lazy(() => import('../views/fleetnexis/driver-helper/TeamAvailibilityChart')),
);
const AddSale = Loadable(lazy(() => import('../views/fleetnexis/store/AddSale')));
const ViewSales = Loadable(lazy(() => import('../views/fleetnexis/store/ViewSales')));
const EditSale = Loadable(lazy(() => import('../views/fleetnexis/store/EditSale')));
const ContactList = Loadable(lazy(() => import('../views/fleetnexis/users/ContactList')));

const PackageServices = Loadable(lazy(() => import('../views/fleetnexis/packages/Services')));
const EditExpense = Loadable(lazy(() => import('../views/fleetnexis/expense/EditExpense')));
const FreeSlots = Loadable(lazy(() => import('../views/fleetnexis/driver-helper/FreeSlots')));
// FN Car — page hidden; sidebar entries commented out too.
// const Car = Loadable(lazy(() => import('../views/fleetnexis/driver-helper/Car')));
const DeleteBookings = Loadable(lazy(() => import('../views/fleetnexis/booking/DeleteBookings')));
const AllCars = Loadable(lazy(() => import('../views/fleetnexis/store/AllCars')));
const AdditionalServices = Loadable(lazy(() => import('../views/fleetnexis/packages/Additional')));

// Tenancy
const Tenants = Loadable(lazy(() => import('../views/fleetnexis/tenants/Tenants')));
const PanelUsers = Loadable(lazy(() => import('../views/fleetnexis/tenants/PanelUsers')));

const Routernew = () => {
  const { token, setToken } = UserToken();
  const { pathname } = useLocation();
  const logout = endSession;
  // Another tab logging in or out resets this one (see watchSessionInOtherTabs).
  useEffect(() => watchSessionInOtherTabs(), []);
  useEffect(() => {
    // Sessions from before roles/tenants have no user_role in the stored user;
    // log them in again so menus, tenant and time zone come from the API.
    const storedUser = getStoredUser();
    if (token && storedUser && !storedUser.user_role) {
      logout();
      return undefined;
    }
    const checkTokenExpiration = () => {
      if (token) {
        try {
          const decoded = jwt.decode(token);
          const expiresAt = decoded && typeof decoded === 'object' ? decoded.exp : null;

          if (!expiresAt || expiresAt < Date.now() / 1000) {
            logout();
          }
        } catch (error) {
          logout();
          console.error('Error decoding token:', error);
        }
      }
    };

    const intervalId = setInterval(() => {
      checkTokenExpiration();
    }, 1000 * 60); // Check every minute

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, [token]);
  // Password recovery is public: an emailed reset link opens it even in a
  // browser where someone is already logged in.
  const isRecoveryPage = ['/forgot-password', '/reset-password'].includes(pathname.toLowerCase());
  if (!token || isRecoveryPage) {
    return <LoginFormik setToken={setToken} />;
  }
  return (
    <div>
      <Routes>
        <Route path="/" element={<FullLayout></FullLayout>}>
          <Route path="/" element={<Classic />} />
          <Route path="/dashboard" name="dashboard" element={<Classic />}></Route>
          <Route path="/teamSlotSchedule" element={<TeamSlotSchedule />} />
          <Route path="/AllUsers" name="AllUsers" element={<AllUsers />}></Route>
          <Route path="/userAnalysis" name="UserAnalysis" element={<UserAnalysis />}></Route>
          <Route path="/filterUser" name="filterUser" element={<FilterUser />}></Route>
          <Route path="/NoResponse" name="NoResponse" element={<NoResponse />}></Route>
          <Route path="/NotRetrieved" name="NotRetrieved" element={<NotRetrieved />}></Route>
          <Route path="/RetrievedUser" name="RetrievedUser" element={<RetrievedUser />}></Route>
          <Route path="/usersByStatus" name="UsersByStatus" element={<UsersByStatus />}></Route>
          <Route path="/driverHelper" name="driverHelper" element={<DriverHelper />}></Route>
          <Route path="/reports" name="reports" element={<AdminsOnly><Reports /></AdminsOnly>}></Route>
          <Route path="/workstationreports" name="wreports" element={<AdminsOnly><WorkStation /></AdminsOnly>}></Route>
          {/* <Route path="/bonus" name="bonus" element={<Bonus />}></Route> */}
          <Route path="/deletesystem" name="deletesystem" element={<AdminsOnly><DeleteSystem /></AdminsOnly>}></Route>
          <Route path="/cashcollection" name="cashcollection" element={<AdminsOnly><CashCollection /></AdminsOnly>}></Route>
          <Route path="/maplocation" name="maplocation" element={<MapLocation />}></Route>
          <Route path="/addservices" name="addservices" element={<AdminsOnly><AddService /></AdminsOnly>}></Route>
          <Route path="/viewservices" name="viewservices" element={<AdminsOnly><ViewServices /></AdminsOnly>}></Route>
          <Route path="/editService" name="editService" element={<AdminsOnly><EditServices /></AdminsOnly>}></Route>
          <Route path="/contactEnquiry" name="contactEnquiry" element={<ContactEnquiry />}></Route>
          <Route path="/bookingEnquiry" name="bookingEnquiry" element={<BookingEnquiry />}></Route>
          <Route path="/areaManagement" name="areaManagement" element={<AdminsOnly><AreaManagement /></AdminsOnly>}></Route>
          <Route path="/rolesCountries" name="rolesCountries" element={<AdminsOnly><RolesCountries /></AdminsOnly>}></Route>
          <Route
            path="/tenants"
            name="tenants"
            element={
              <RequireRole roles={[ROLES.SUPER_ADMIN, ROLES.TENANT_ADMIN]}>
                <Tenants />
              </RequireRole>
            }
          ></Route>
          <Route
            path="/panelUsers"
            name="panelUsers"
            element={
              <RequireRole roles={[ROLES.SUPER_ADMIN, ROLES.TENANT_ADMIN]}>
                <PanelUsers />
              </RequireRole>
            }
          ></Route>
          <Route
  path="/categoryManagement"
  name="categoryManagement"
  element={<AdminsOnly><CategoryManagement /></AdminsOnly>}
/>
<Route
  path="/mobileMedia"
  name="mobileMedia"
  element={<AdminsOnly><MobileMedia /></AdminsOnly>}
/>
          <Route path="/SortWallet" name="bookingEnquiry" element={<SortWallet />}></Route>
          <Route path="/SortWallet" name="bookingEnquiry" element={<SortWallet />}></Route>
          <Route path="/paymentGateway" name="paymentGateway" element={<AdminsOnly><PaymentGateway /></AdminsOnly>}></Route>
          <Route path="/QuoteGenerator" name="QuoteGenerator" element={<AdminsOnly><QuoteGenerator /></AdminsOnly>}></Route>
          <Route path="/slotBooking" name="slotBooking" element={<SlotBooking />}></Route>
          <Route path="/viewbooking" name="viewBookings" element={<ViewBookings />}></Route>
          {/* <Route path="/userLogs" name="userLogs" element={<UserLogs />}></Route> */}
          {/* <Route path="/userNewLogs" name="userNewLogs" element={<UserNewLogs />}></Route> */}
          <Route path="/editBooking/:id" name="editBooking" element={<EditBookingNew />}></Route>
          <Route path="/teams" name="teams" element={<Teams />}></Route>
          <Route path="/map" name="map" element={<MapFilterForm />}></Route>
          <Route path="/quoteInvoice" name="quoteInvoice" element={<BookingQuotePdf />}></Route>
          <Route path="/todaymap" name="todaymap" element={<TodayMapLocation />}></Route>
          <Route
            path="/bookinganalysis"
            name="todaymap"
            element={<BookingMonthlyAnalysis />}
          ></Route>

          <Route path="/complaints" name="complaints" element={<Complaints />}></Route>
          <Route path="/viewComplaints" name="ViewComplaints" element={<ViewComplaints />}></Route>
          <Route path="/addComplaints" name="AddComplaints" element={<AddComplaints />}></Route>
          <Route path="/consent" name="Consent" element={<Consent />}></Route>
          <Route path="/Schedule" name="Schedule" element={<Schedule />}></Route>
          <Route
            path="/workstationview"
            name="WorkStationView"
            element={<WorkStationView />}
          ></Route>
          <Route path="/quote" name="quote" element={<Quotation />}></Route>
          <Route path="/expense" name="expense" element={<AdminsOnly><Expense /></AdminsOnly>}></Route>
          <Route
            path="/workstationedit/:id"
            name="EditBookingWorkstation"
            element={<EditBookingWorkstation />}
          ></Route>
          {/* <Route
            path="/getBookingDetailById"
            name="GetBookingDetailById"
            element={<GetBookingDetailById />}
          ></Route> */}
          <Route path="/viewquote" name="viewQuotation" element={<ViewQuotation />}></Route>
          <Route path="/editquote/:id" name="Editquote" element={<Editquote />}></Route>
          <Route path="/cafu" name="cafu" element={<AdminsOnly><Cafu /></AdminsOnly>}></Route>
          <Route path="/audiorecorder" name="AudioRecorder" element={<AudioRecorder />}></Route>

          <Route path="/issues" name="Issues" element={<Issues />}></Route>
          <Route path="/inspection" name="Inspection" element={<Inspection />}></Route>

          <Route
            path="/inspectionDetail/:id"
            name="InspectionDetail"
            element={<InspectionDetail />}
          ></Route>
          <Route path="/storelist" name="StoreList" element={<StoreList />}></Route>
          <Route path="/addproduct" name="AddProduct" element={<AdminsOnly><AddProduct /></AdminsOnly>}></Route>
          <Route path="/editproduct/:id" name="EditProduct" element={<AdminsOnly><EditProduct /></AdminsOnly>}></Route>
          <Route path="/transferlist" name="transferlist" element={<TransferList />}></Route>
          <Route path="/quantityalert" name="QuantityAlert" element={<QuantityAlert />}></Route>
          {/* <Route path="/recharge" name="recharge" element={<Recharge />}></Route> */}
          <Route path="/salereport" name="SaleReport" element={<AdminsOnly><SaleReport /></AdminsOnly>}></Route>
          <Route
            path="/teamavailibility"
            name="TeamAvailibilityChart"
            element={<TeamAvailibilityChart />}
          ></Route>
          <Route path="/addsale" name="AddSale" element={<AdminsOnly><AddSale /></AdminsOnly>}></Route>
          <Route path="/viewsale" name="ViewSales" element={<ViewSales />}></Route>
          <Route path="/editsale/:id" name="EditSale" element={<EditSale />}></Route>
          <Route path="/contactlist" name="ContactList" element={<ContactList />}></Route>
          <Route path="/packages" name="PackageServices" element={<AdminsOnly><PackageServices /></AdminsOnly>}></Route>
          <Route path="/editExpense" name="EditExpense" element={<AdminsOnly><EditExpense /></AdminsOnly>}></Route>
          <Route path="/freeslots" name="FreeSlots" element={<FreeSlots />}></Route>
          {/* <Route path="/car" name="Car" element={<Car />}></Route> */}
          <Route path="/delete-booking" name="DeleteBookings" element={<AdminsOnly><DeleteBookings /></AdminsOnly>}></Route>
          <Route path="/allcars" name="AllCars" element={<AllCars />}></Route>
          <Route path="/brands" name="Brands" element={<Brands />}></Route>
          <Route
            path="/additional-services"
            name="AdditionalServices"
            element={<AdminsOnly><AdditionalServices /></AdminsOnly>}
          ></Route>
          <Route path="/leads" name="Leads" element={<Leads />}></Route>
        </Route>
      </Routes>
    </div>
  );
};

export default Routernew;
